// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b0c802be","351":"54b37ee1"}[chunkId] + ".chunk.js";
};